export default import.meta.ROLLDOWN_FILE_URL_c2RsTfcfJoZNy5W2Jzmy2w